import axios from "axios";
import router from "@/router";

const axiosInstance =  axios.create({
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

axiosInstance.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}, function (error) {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    const { response, message } = error

    if (response) {
		/*INFO: Hande taxes request (at the moment it's not compatible with no-auth (should be refactored)*/
		const check_taxes_request = error.request.responseURL.includes('taxes')
        if (response.status === 401 && !check_taxes_request) {
            router.push('/login')
        }
        // backend error
        //alert(error.response.data.message)
    } else if (message) { // network error
        //alert(message)
    }
    return Promise.reject(error)
});

export default axiosInstance;
